import { useRef, memo } from "react";
import { ESIIncludeWithClientFetch } from "../__shared__/ESIIncludeWithClientFetch/ESIIncludeWithClientFetch";
import styles from "./Recommendations.module.scss";

export type Props = {
  /**
   * A string representing the product ID from the Product Information Management system.
   */
  productId: string;
  /**
   * A string representing the SKU ID of the product.
   */
  skuId: string;
  /**
   * A string representing the placement of the product.
   */
  placement: string;
  /**
   * A string representing the maximum number of products per page.
   */
  maxProductsPerPage: string;
  /**
   * A string indicating whether refresh is allowed.
   */
  allowRefresh?: string;
  /**
   * A string indicating Recommendation panel type
   */
  type?: "small" | "small-manual-recs";
  /**
   * Boolean that represents if responsive styling should be used
   */
  isResponsiveStylesEnabled?: boolean;
  /**
   * Boolean that represents if recommendations should have no outer spacing
   */
  isNoOuterSpacingEnabled: boolean;
  /**
   * Boolean that represents if new premium button styling should be used
   */
  isCtaPremiumDesign?: boolean;
  /**
   * Boolean that represents if new square colour swatches are enabled
   */
  isPremiumColourSelector?: boolean;
  /**
   * Boolean that represents if new was price is enabled
   */
  isHasNowWasPriceEnabled?: boolean;
  /**
   * Boolean that represents if new whole pounds only is enabled (do decimals)
   */
  isHasWholePoundsOnlyEnabled?: boolean;
};

export const RecommendationsUI = memo(function RecommendationsUI({
  placement,
  productId,
  skuId,
  maxProductsPerPage,
  allowRefresh,
  type,
  isResponsiveStylesEnabled,
  isNoOuterSpacingEnabled,
  isCtaPremiumDesign,
  isPremiumColourSelector,
  isHasNowWasPriceEnabled,
  isHasWholePoundsOnlyEnabled,
}: Props) {
  const className = isResponsiveStylesEnabled
    ? styles.recommendationSectionResponsive
    : "";

  const url = useRef(
    `/esi/recommendations/?${new URLSearchParams({
      placement,
      productId,
      skuId,
      ...(type ? { type } : {}),
      maxProductsPerPage,
      allowRefresh: allowRefresh || "false",
      withLoader: "true",
      ffWideLayout: "on",
      ffNoOuterSpacing: isNoOuterSpacingEnabled ? "on" : "off",
      ...(className ? { className } : {}),
      ...(isCtaPremiumDesign ? { ffJLDSv31Patch: "off" } : {}),
      ...(isPremiumColourSelector ? { ffSquareSwatches: "on" } : {}),
      ...(isHasNowWasPriceEnabled ? { ffHasNowWasPriceEnabled: "on" } : {}),
      ...(isHasWholePoundsOnlyEnabled
        ? { ffHasWholePoundsOnlyEnabled: "on" }
        : {}),
    }).toString()}`,
  );

  return (
    <div
      data-testid={`recommendations-${placement.toLowerCase()}`}
      className="esi-wrapper"
      data-component="Recommendations"
    >
      <ESIIncludeWithClientFetch
        id={`jl-recommendations-panel-esi-${placement.toLowerCase()}`}
        src={url.current}
      />
    </div>
  );
});
